<!-- @format -->

<section [attr.aria-label]="'AUTH.CHANGE_LANGUAGE' | transloco">
  <div ngbDropdown #dropdown="ngbDropdown" class="language-selection">
    <button
      type="button"
      ngbDropdownToggle
      class="non-button language-selection__toggle"
      id="language-selection-toggle"
      [attr.aria-haspopup]="'menu'"
      [attr.aria-controls]="'sis-language-selection-menu'"
      [attr.data-cy]="'sis-language-selection-toggle'">
      <span class="d-none d-sm-inline-block">{{ currentLanguageName }}</span>
      <span class="d-inline-block d-sm-none">{{ currentLanguage.toUpperCase() }}</span>
      <fudis-icon [icon]="'chevron'" [rotate]="'cw-90'" />
    </button>
    @if (languageSelections?.length > 0) {
      <div ngbDropdownMenu id="sis-language-selection-menu" role="menu" class="dropdown-menu-right language-selection__menu">
        @for (selection of languageSelections; track selection) {
          <button
            type="button"
            ngbDropdownItem
            role="menuitem"
            class="language-selection__menu__item"
            (click)="changeLanguage(selection.language)"
            (blur)="blurMenu($event)"
            [lang]="selection.language"
            [attr.aria-current]="selection.language === currentLanguage"
            [attr.data-cy]="'sis-language-selection-option-' + selection.language">
            {{ selection.name }}
            @if (selection.language === currentLanguage) {
              <fudis-icon class="sis-ml-xs" [icon]="'check'" [color]="'primary'" />
            }
          </button>
        }
      </div>
    }
  </div>
  <div class="visually-hidden" aria-live="assertive" aria-atomic="true">
    @if (currentSiteTitle()) {
      <span>
        {{ currentSiteTitle() | transloco }}
      </span>
    }
  </div>
</section>
